import { FC, useEffect } from 'react'
import { useTranslation } from 'next-i18next'

import { useAppDispatch, useAppSelector } from '~/redux/hooks'
import SVGImage from '~/components/Image/SVGImage'
import RemoveButton from '~/bootcamp/Activities/components/RemoveButton'
import ActivityAnswerButton from '~/bootcamp/components/ActivityAnswerButton'
import { ActivityActionButtons } from '~/bootcamp/Activities/types/activities.types'
import {
  selectAnswerState,
  selectCorrectConsecutiveAnswers,
  selectIsRewardFeedbackScreenOpen,
  selectShouldAutoValidateAnswer,
  selectShouldDisableUserInteraction,
  setShouldResetInputActionCreator,
} from '~/bootcamp/slices/bootcamp-activity.slice'

const CheckAnswerAndClearButton: FC<ActivityActionButtons> = (props) => {
  // const [isHintAvailable, setIsHintAvailable] = useState(false)
  const dispatch = useAppDispatch()
  const shouldDisableUserInteraction = useAppSelector(selectShouldDisableUserInteraction)
  const answerState = useAppSelector(selectAnswerState)
  const showOpenForCheat = useAppSelector(selectShouldAutoValidateAnswer)
  const isRewardFeedbackScreenOpen = useAppSelector(selectIsRewardFeedbackScreenOpen)
  const { t } = useTranslation(['generics', 'bootcampQuiz'])

  // useEffect(() => {
  //   if (answerState === false) {
  //     setIsHintAvailable(true)
  //   }
  // }, [answerState])
  // if (!props) return <></>

  const { formValid, correctAnswer, clearFormAction, submitAnswerAction, goToNextQuestionAction } = props

  const onResetClick = (): void => {
    clearFormAction()
    dispatch(setShouldResetInputActionCreator(true))
  }

  const consecutiveAnswers = useAppSelector(selectCorrectConsecutiveAnswers)

  useEffect(() => {
    if (goToNextQuestionAction && correctAnswer && consecutiveAnswers >= 3 && !isRewardFeedbackScreenOpen) {
      goToNextQuestionAction()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRewardFeedbackScreenOpen])

  const buttonPrimary = (): React.ReactElement => {
    return (
      <ActivityAnswerButton
        className={
          correctAnswer
            ? 'w-43 bg-gradient-green ring-green-medium hover:ring-green-cyan border border-black text-black-breadcrumb'
            : 'w-35 text-white'
        }
        disabled={!showOpenForCheat && ((!formValid && !correctAnswer) || shouldDisableUserInteraction)}
        onClick={correctAnswer ? goToNextQuestionAction : submitAnswerAction}
        size="small"
        type="submit"
      >
        {correctAnswer ? t('generics:nextQuestion') : t('bootcampQuiz:check')}
      </ActivityAnswerButton>
    )
  }

  const buttonRemove = (): React.ReactElement => {
    // Not gated on formValid: the step-working fields (carried digits, quotients) are filled long
    // before the answer row is, and those are the ones the pupil needs to clear. Clicking it with
    // nothing filled in is a no-op.
    return <RemoveButton disabled={correctAnswer || shouldDisableUserInteraction} onClick={onResetClick} />
  }

  // const onHintClick = (): void => {
  //   dispatch(setShouldGetActivityHintActionCreator(true))
  //   setIsHintAvailable(false)
  // }
  return (
    <div className="flex space-x-2 justify-center md:pb-6 exclude-from-screenshot" data-testid="check-answer-and-clear">
      {answerState != null && (
        <div className="flex w-8">
          {answerState && <SVGImage height={32} srcKey="bootcamp/checkmark-green-border.svg" width={41} />}
          {answerState === false && (
            <SVGImage alt="red-border-icon" height={32} srcKey="bootcamp/cross-red-border.svg" width={30} />
          )}
        </div>
      )}
      <div className="flex flex-col space-y-3">
        {buttonPrimary()}
        {buttonRemove()}
      </div>
      {/* <div className="w-8">
        {isHintAvailable ? (
          <button className="animate-shake cursor-pointer exclude-from-screenshot" onClick={onHintClick}>
            <ResponsiveImage
              alt="lightbulb-off-icon"
              height={32}
              imageWidths="48"
              srcKey="oracle-ai/hint-on.png"
              width={32}
            />
          </button>
        ) : (
          <div className="exclude-from-screenshot">
            <ResponsiveImage
              alt="lightbulb-off-icon"
              height={32}
              imageWidths="48"
              srcKey="oracle-ai/hint-off.png"
              width={32}
            />
          </div>
        )}
      </div> */}
    </div>
  )
}

export default CheckAnswerAndClearButton
